import { render } from "./qs-sxpr-swp-view.vue?vue&type=template&id=34556db8"
import script from "./qs-sxpr-swp-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qs-sxpr-swp-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/qs-sxpr-swp-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34556db8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34556db8', __exports__)) {
    api.reload('34556db8', __exports__)
  }
  
  module.hot.accept("./qs-sxpr-swp-view.vue?vue&type=template&id=34556db8", () => {
    api.rerender('34556db8', render)
  })

}


export default __exports__